// Where the SPA sources the clinic subdomain it sends in the `/auth/login`
// body. Deployed hosts are `<subdomain>.brian-frontend.<…>`, so the leading
// DNS label is the clinic. On localhost / IPs there's no subdomain to read, so
// this returns null and the login screen collects it via a dev-only input.
// The backend treats the Host header only as a fallback (see
// modules/clinic/subdomain.extract_subdomain), so the body value is primary.

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);
const IPV4 = /^\d{1,3}(?:\.\d{1,3}){3}$/;

/**
 * The clinic subdomain implied by `hostname`, or `null` when it can't be
 * derived (localhost, IPs, or a bare apex domain with no leading label).
 */
export const deriveSubdomainFromLocation = (
  hostname: string = window.location.hostname,
): string | null => {
  const host = hostname.trim().toLowerCase().replace(/\.$/, "");
  if (
    !host ||
    LOCAL_HOSTS.has(host) ||
    host.endsWith(".localhost") ||
    IPV4.test(host)
  ) {
    return null;
  }
  const labels = host.split(".");
  // Need a real domain beneath the leading label (`demo.brian-frontend.…` →
  // `demo`); a bare `example.com` has no subdomain to read.
  if (labels.length < 3 || !labels[0]) return null;
  return labels[0];
};
